import { render, staticRenderFns } from "./ObservacionNew.vue?vue&type=template&id=9373e0a6&scoped=true&"
import script from "./ObservacionNew.vue?vue&type=script&lang=js&"
export * from "./ObservacionNew.vue?vue&type=script&lang=js&"
import style0 from "./ObservacionNew.vue?vue&type=style&index=0&id=9373e0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9373e0a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VTextarea,
})
